import { combineReducers } from 'redux';

import { FORM_LOAD, FORM_INIT_LOAD } from '../actions/types';

const initialState = {
    slaname: '',
    responsehours: '',
    responsemins: '',
    resolvemins: '',
    resolvehours: '',
    hourtype:'calendar'
}

export const slaForm = (state = initialState, action) => {
    switch (action.type) {
        case FORM_LOAD:
            return {
                ...state, ...action.data
            }
        case FORM_INIT_LOAD:
            return {
                initialState
            }
        default:
            return state
    }
}
export default combineReducers({
    slaForm
});
